import { FT } from 'ft'
import { Graphics } from 'pixi.js'

class Mask extends Graphics {
  constructor() {
    super()
    this.beginFill(0x000000, 0.7)
    this.drawRect(0, 0, FT.stage.width, FT.stage.height)
    this.endFill()
  }
}

export default Mask
